import { OnboardingAction, OnboardingData } from "./model";

function onboardingDataReducer(state: OnboardingData, action: OnboardingAction): OnboardingData {
  switch (action.type) {
    case "CREATED_INPUT":
      return { ...state, input: { id: action.id } };
    case "CREATED_TEMPLATE":
      return { ...state, template: { id: action.id, status: "created" } };
    case "DEPLOYED_TEMPLATE":
      return { ...state, template: { id: action.id, status: "deployed" } };
    case "DELETE_TEMPLATE":
      return { ...state, template: action.id === state.template?.id ? null : { ...state.template } };
    case "SET_HIDDEN":
      return { ...state, hidden: action.value };
    case "CREATED_WORKSHEET":
      return { ...state, worksheet: { id: action.id } };
    default:
      throw new Error(`Unknown action ${action && JSON.stringify(action)}`);
  }
}

export default onboardingDataReducer;
